// extracted by mini-css-extract-plugin
export default {"input":"zcPslbuXXrWaKXh1xr4kPw=="};